import { render, staticRenderFns } from "./StartupsBySource.vue?vue&type=template&id=3387ddc0"
import script from "./StartupsBySource.vue?vue&type=script&lang=js"
export * from "./StartupsBySource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports